"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var __aws_sdk_apply_body_checksum_middleware = require("@aws-sdk/apply-body-checksum-middleware");
var __aws_sdk_bucket_endpoint_middleware = require("@aws-sdk/bucket-endpoint-middleware");
var __aws_sdk_middleware_stack = require("@aws-sdk/middleware-stack");
var PutBucketReplication_1 = require("../model/PutBucketReplication");
var PutBucketReplicationCommand = /** @class */ (function () {
    function PutBucketReplicationCommand(input) {
        this.input = input;
        this.model = PutBucketReplication_1.PutBucketReplication;
        this.middlewareStack = new __aws_sdk_middleware_stack.MiddlewareStack();
    }
    PutBucketReplicationCommand.prototype.resolveMiddleware = function (clientStack, configuration) {
        var handler = configuration.handler;
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {},
            model: this.model
        };
        stack.add(__aws_sdk_bucket_endpoint_middleware.bucketEndpointMiddleware({
            forcePathStyle: configuration.forcePathStyle,
            preformedBucketEndpoint: configuration.bucketEndpoint,
            useAccelerateEndpoint: configuration.useAccelerateEndpoint,
            useDualstackEndpoint: configuration.useDualstackEndpoint
        }), {
            step: "build",
            priority: 0
        });
        stack.add(__aws_sdk_apply_body_checksum_middleware.applyBodyChecksumMiddleware("Content-MD5", configuration.md5, configuration.base64Encoder, configuration.streamHasher), {
            step: "build",
            priority: 0,
            tags: { BODY_CHECKSUM: true }
        });
        return stack.resolve(handler(handlerExecutionContext), handlerExecutionContext);
    };
    return PutBucketReplicationCommand;
}());
exports.PutBucketReplicationCommand = PutBucketReplicationCommand;
//# sourceMappingURL=PutBucketReplicationCommand.js.map